export type OriginalQuestionData = {
	stem: string;
	explanation?: string;
	choices: Choice[];
	topics: string[];
	selectedChoice: SelectedChoice[];
};

type Choice = {
	text?: string;
	isCorrect?: boolean;
};

type SelectedChoice = {
	text?: string;
	isCorrect?: boolean;
	stem?: string;
};
